import { ServerFetch } from '../main-model'

export default class DebitMethodTypeModel extends ServerFetch {
    getDebitMethodTypeBy = (data) => this.authFetch({
        url: 'debit-method-type/getDebitMethodTypeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}